import { SideMenuItem } from "../interfaces/config/sideMenu";
import {
  LayoutDashboard,
  Stethoscope,
  UserRound,
  Cross,
  BookOpen,
  MessageCircle,
  Calculator,
  Landmark,
  FileText,
  Settings,
  CircleDollarSign,
  Building2,
  FilePlus2,
} from "lucide-react";
import { routes } from "./routes";

const sideMenuItems: SideMenuItem[] = [
  {
    id: 1,
    icon: LayoutDashboard,
    label: "Dashboard",
    route: routes.dashboard.home,
  },
  {
    id: 2,
    icon: UserRound,
    label: "Patients",
    route: routes.patients.list,
  },
  {
    id: 3,
    icon: MessageCircle,
    label: "Q&A",
    route: routes.qa.home,
    matchChildRoutes: true,
  },
  {
    id: 4,
    icon: Stethoscope,
    label: "GenioMD",
    route: routes.genioMD.list,
    matchChildRoutes: true,
  },
  {
    id: 5,
    icon: Cross,
    label: "Drugs & Diseases",
    route: routes.medical.drugsAndDiseases,
  },
  {
    id: 6,
    icon: BookOpen,
    label: "Congresses & Medical Updates",
    route: routes.medical.congresses,
  },
  {
    id: 7,
    icon: Landmark,
    label: "Billing & Claims",
    route: "#",
    children: [
      {
        id: 701,
        label: "Invoices",
        route: routes.billing.invoices,
        icon: FileText,
      },
      {
        id: 702,
        label: "Claims",
        route: routes.billing.claims,
        icon: FilePlus2,
      },
      {
        id: 703,
        label: "Billing Codes",
        route: routes.billing.codes,
        icon: Landmark,
      },
    ],
  },
  {
    id: 9,
    icon: Settings,
    label: "Settings",
    route: "#", // Parent route
    children: [
      {
        id: 901,
        label: "Currencies",
        route: routes.settings.currencies,
        icon: CircleDollarSign,
      },
      {
        id: 902,
        label: "Insurers",
        route: routes.settings.insurers,
        icon: Building2,
      },
    ],
  },
];

// Define pages that are not in the side menu but need metadata
export const additionalPages: SideMenuItem[] = [
  {
    id: 10,
    icon: UserRound,
    label: "Patient Details",
    route: routes.patients.details(":id"),
  },
  {
    id: 11,
    icon: Calculator,
    label: "Medical Calculators",
    route: routes.medical.calculators,
  },
];

/**
 * The array of side menu items for the application.
 * @type {SideMenuItem[]}
 */
export const sideMenu: SideMenuItem[] = sideMenuItems;
